import {
  BottomNavigation,
  BottomNavigationAction,
  InputLabel,
  TextField,
} from "@mui/material";
import { Box } from "@mui/system";
import React, { Fragment } from "react";
import Header from "./Header";
import { Form, Formik, useFormik } from "formik";
import * as yup from "yup";
import { useLocation, useNavigate } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { useTranslation } from "react-i18next";
import { toast, ToastContainer } from "react-toastify";
import { getSiteDetails, getlocationlist, sendMessage, sendOTP } from "../API";
import { useDispatch, useSelector } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import { useEffect } from "react";
import { useState } from "react";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Footer from "./Footer";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { currencyFormatter } from "../utils";
import { Link } from "react-router-dom";
import {
  DecrementCount,
  IncrementCount,
  storecurrency,
} from "../redux/Actions";

function Details() {
  const [btndisable, setbtndisable] = useState(false);
  const [deliveryCharge, setDeliveryCharge] = useState(0);
  const [discountBannerValue, setDiscountBannerValue] = useState(
    process.env.REACT_APP_MIN_CART_VALUE
  );

  const dispatch = useDispatch();
  const { cart, totalitems, totalPrice } = useSelector((state) => state.IC);
  const [siteDetails, setSiteDetails] = useState();

  // if (
  //   !Array.isArray(cart) &&
  //   typeof cart === "object" &&
  //   localStorage.getItem("persist:root")
  // ) {
  //   localStorage.setItem(
  //     "persist:root",
  //     '{"IC":"{\\"cart\\":[],\\"totalitems\\":0,\\"totalPrice\\":0}","ItemsListReducer":"[]","otpNumberReducer":"[]","paymentReducer":"{\\"Payment_refrence\\":{}}","storeCurrencyReducer":"{}","storelanguagereducer":"{\\"storelanguage\\":\\"English\\"}","storemapIdreducer":"{}","_persist":"{\\"version\\":-1,\\"rehydrated\\":true}"}'
  //   );
  //   window.location.reload(false);
  // }

  const Data = useLocation();
  const storeConturyCode = Data.state.statetwo.countryCode;
  const { storeCurrency } = useSelector((state) => state.storeCurrencyReducer);
  const { storelanguage } = useSelector((state) => state.storelanguagereducer);
  const cartData = Data.state?.cartdata;
  const locationName = Data.state?.locationName;
  const storeId = Data.state?.storeId;
  const navigate = useNavigate();
  const otpError = () => {
    toast.error(
      Data?.state?.statetwo?.toastTexts?.otpSendError[storelanguage?.code]
    );
    // storelanguage?.name === "English"
    //   ? toast.error("OTP send Failed")
    //   : toast.error("Invio OTP non riuscito");
  };
  const otpSuccess = () =>
    toast.success(
      Data?.state?.statetwo?.toastTexts?.otpSendSuccess[storelanguage?.code]
    );
  // storelanguage?.name === "English"
  //   ? toast.success("OTP send successfully")
  //   : toast.success("Invio OTP riuscito");

  const phoneRegExp =
    /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
  const validationSchema = yup.object({
    contactno: yup
      .string()
      .matches(
        phoneRegExp,
        `${
          storelanguage?.name === "English"
            ? "Phone number is not valid"
            : "Il numero di telefono non è valido"
        }`
      )
      .required(
        `${
          storelanguage?.name === "English"
            ? "Phone Number is required"
            : "Il numero di telefono è obbligatorio"
        }`
      ),
    username: yup
      .string()
      .required(
        `${
          storelanguage?.name === "English"
            ? "User Name is required"
            : "È richiesto il nome utente"
        }`
      ),
    agree: yup
      .string()
      .required(
        `${
          storelanguage?.name === "English"
            ? "Please select this"
            : "Per favore seleziona questo"
        }`
      ),
  });
  const storetype = localStorage.getItem("store_type");
  // console.log('Data.state.storeId',Data.state.storeId)
  const formik = useFormik({
    initialValues: {
      contactno: storeConturyCode,
      username: "",
      agree: true,
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      if (cart.length === 0 || parseFloat(totalPrice) === 0) {
        toast.error(
          Data?.state?.statetwo?.billDetailsTexts?.cartEmpty[
            storelanguage?.code
          ]
        );
        // if (storelanguage?.name === "English") {
        //   toast.error("Your Cart is Empty.");
        // } else {
        //   toast.error("Il tuo carrello è vuoto");
        // }
      } else {
        // console.log(discountBannerValue,"discountBannerValue")
        if (discountBannerValue && totalPrice < discountBannerValue) {
          toast.error(
            Data?.state?.statetwo?.toastTexts?.orderMinimumAmount[
              storelanguage?.code
            ].replace(
              "[variable_value]",
              currencyFormatter(discountBannerValue, storeCurrency)
            )
          );
          // `Minimum order amount is ${currencyFormatter(
          //   discountBannerValue,
          //   storeCurrency
          // )}. Please add more items.`
          return;
        }
        //  console.log('values',values)
        let message = Math.floor(100000 + Math.random() * 900000);
        // sendMessage(values.contactno, message, {
        //   customerName: values.username,
        //   language: storelanguage?.name,
        // })
        sendOTP(values.contactno, values.username, storelanguage?.name)
          .then((res) => {
            // console.log('OTP Send Success' ,res)
            if (res.data.status === 200 || res.data.status === "200") {
              let contactNo = values.contactno;
              let username = values.username;
              otpSuccess();
              navigate("/cart", {
                state: {
                  cartData,
                  message,
                  locationName: locationName,
                  contactNo,
                  username,
                  statetwo: Data?.state?.statetwo,
                  totalPrice: Data?.state?.totalPrice,
                  deliveryCharge: Data?.state?.deliveryCharge,
                  totaltax: Data?.state?.totaltax,
                  storeId,
                },
              });
              setbtndisable(true);
            }
          })
          .catch((err) => {
            console.error("Error in send OTP", err);
            otpError();
          });
      }
    },
  });
  const onValueChange = (value) => {
    formik.setFieldValue("contactno", value);
  };
  const handlecartedit = () => {
    navigate(`/storelist/${Data?.state?.statetwo?._id}`, {
      state: { item: Data?.state?.statetwo },
    });
  };
  // console.log('Data',Data)
  const label = { inputProps: { "aria-label": "Checkbox demo" } };

  const handleagreechange = (e) => {
    if (e.target.checked) {
      formik.setFieldValue("agree", e.target.checked);
    } else {
      formik.setFieldValue("agree", "");
    }
  };

  const variantCount = (cartItem) => {
    if (Array.isArray(Object.values(cartItem)[0])) {
      let quantityCount = Object.values(cartItem)[0].map(
        (variantItem, index) => {
          return 1;
        }
      );
      return quantityCount;
    } else {
      return `${Object.values(cartItem)[0]}`;
    }
  };

  useEffect(() => {
    dispatch(storecurrency(Data?.state?.statetwo?.currency));
  }, []);

  const CalculateVariantsQuantity = ({ cartItems }) => {
    let filteredCartItems = cartItems.reduce((uniqueVariant, variant) => {
      if (!uniqueVariant[Object.keys(variant)[0]]) {
        let uniqueVariantObject = Object.keys(variant).includes(
          "multipleVariants"
        )
          ? {
              variantCount: 1,
              product: Object.values(variant)[1],
              productVariant: Object.values(variant)[2],
              multipleVariants: Object.values(variant)[3],
            }
          : {
              variantCount: 1,
              product: Object.values(variant)[1],
              productVariant: Object.values(variant)[2],
            };
        uniqueVariant[Object.keys(variant)[0]] = uniqueVariantObject;
      } else if (uniqueVariant[Object.keys(variant)[0]]) {
        uniqueVariant[Object.keys(variant)[0]].variantCount += 1;
      }

      return uniqueVariant;
    }, []);

    return (
      <div className="flex flex-col gap-2">
        {Object.values(filteredCartItems).length > 0 &&
          Object.values(filteredCartItems).map((cartItem, index) => (
            <div
              key={"filtered__cart__item__no__" + index}
              // className="flex flex-col gap-1"
              className="grid grid-cols-[50%_50%] items-center"
            >
              <span className="text-[0.9rem] font-medium capitalize">
                {cartItem?.multipleVariants?.length > 0 ? (
                  <>
                    {cartItem.multipleVariants
                      .map((variant) => variant?.name[storelanguage?.code])
                      .join(", ")
                      .toLowerCase()}
                  </>
                ) : (
                  <>
                    {cartItem.productVariant?.name[
                      storelanguage?.code
                    ].toLowerCase()}
                  </>
                )}
              </span>
              <div className="cart__product__list__container">
                <div className="cart__product__list__wrapper">
                  {/* <div
                    key={"variant__increment__modal__variant__div__" + index}
                    className="!w-full shadow-none variant__increment__modal__variant__add__btn__wrapper border-none"
                    // className="Productlist_product_counter_wrapper"
                  > */}
                  <button
                    className="ItemsListPage-ItemsList-Counter-btn !py-[5px]"
                    onClick={() => {
                      dispatch(
                        DecrementCount(
                          cartItem.product,
                          cart,
                          totalPrice,
                          cartItem.product?.variant?.length !== 0
                            ? {
                                product: cartItem.product,
                                variantProduct: cartItem.productVariant,
                                multipleVariants:
                                  cartItem?.multipleVariants?.length > 0
                                    ? cartItem?.multipleVariants
                                    : undefined,
                              }
                            : undefined
                        )
                      );
                    }}
                  >
                    {" "}
                    -{" "}
                  </button>
                  <input
                    type="number"
                    style={{
                      WebkitAppearance: "none",
                      margin: 0,
                      color: "var(--theme-primary)",
                      minWidth: "10px",
                    }}
                    readOnly
                    value={cartItem.variantCount}
                    className="ItemsListPage-ItemsList-Counter-input"
                  />
                  <button
                    className="ItemsListPage-ItemsList-Counter-btn !py-[5px]"
                    onClick={() => {
                      dispatch(
                        IncrementCount(
                          cartItem.product,
                          cart,
                          totalPrice,
                          cartItem.product?.variant?.length !== 0
                            ? {
                                product: cartItem.product,
                                variantProduct: cartItem.productVariant,
                                multipleVariants:
                                  cartItem?.multipleVariants?.length > 0
                                    ? cartItem?.multipleVariants
                                    : undefined,
                              }
                            : undefined
                        )
                      );
                    }}
                  >
                    {" "}
                    +{" "}
                  </button>{" "}
                  {/* </div> */}
                </div>
                <span className="cart__order__price !font-normal !text-[14px]">
                  {currencyFormatter(
                    (cartItem.product.price * cartItem.variantCount).toFixed(2),
                    storeCurrency
                  )}
                  {/* {(cartItem.product.price * cartItem.variantCount).toFixed(2)} */}
                </span>
              </div>
            </div>
          ))}
      </div>
    );
  };

  const itemsCount = (cartItem) => {
    if (Array.isArray(Object.values(cartItem)[0])) {
      // return cartItem[0].product.image
      return 1;
    } else {
      return Object.values(cartItem)[0];
    }
  };

  useEffect(() => {
    setDeliveryCharge(Data?.state?.statetwo?.deliveryfee);
    // let totalpricearr = [];
    // Data?.state?.stateone.map((item) => {
    //   totalpricearr.push(item.price * item.count);
    //   return null;
    // });
  }, []);

  useEffect(() => {
    getSiteDetails(process.env.REACT_APP_SITE_NAME)
      .then((res) => {
        setSiteDetails(res.data.message);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    if (
      !Data?.state ||
      Data?.state === undefined ||
      Data?.state === null ||
      Data?.state === "null"
    ) {
      window.location.replace("/");
    }
  }, [Data?.state]);

  return (
    <>
      <div className="MainWhole-wrapper-container">
        <Header arrow={false} siteDetails={siteDetails} />
        <div className="DetailsPage-Main-wrapper">
          {/* <h2> {t('cart_page_heading')}</h2> */}
          <span className="text-[18px] font-bold">
            {/* {Data?.state?.statetwo?.detailsText?.title[storelanguage?.code]} */}
            {Data?.state?.statetwo?.detailsText?.title[storelanguage?.code]}
          </span>
          <h2> </h2>
          <form
            onSubmit={formik.handleSubmit}
            // style={{height:'100vh'}}
          >
            <div className="DetailsPage-content-wrapper !px-[20px]">
              <div className="DetailsPage-content-wrapper-inner">
                {/* <InputLabel style={{fontFamily:"'Poppins', sans-serif"}} className='detailspage-content-label'> {t('cart_page_phone_number')} <sup style={{color:"red"}}>*</sup></InputLabel> */}
                <h3 className="DetailsPage-content-wrapper-inner_h3 !text-[14px]">
                  {
                    Data?.state?.statetwo?.detailsText?.phoneNumberTitle[
                      storelanguage?.code
                    ]
                  }
                  {/* {storelanguage?.name === "English"
                    ? "Enter Phone Number*"
                    : "Número de teléfono*"} */}
                </h3>
                <div
                  style={{
                    marginTop: "10px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <div
                    className="inline"
                    style={{ width: "100%", margin: "auto" }}
                  >
                    <PhoneInput
                      style={{ marginBottom: "10px", textAlign: "justify" }}
                      country={"us"}
                      specialLabel="Phone Number"
                      enableSearch={true}
                      autoFocus={true}
                      value={formik.values.contactno}
                      onChange={(value) => onValueChange(value)}
                      countryCodeEditable={false}
                      margin="standard"
                      name="contactno"
                      label="Phone Number"
                      required
                      containerStyle={{}}
                      inputStyle={{
                        border: "2px solid #70707087",
                        width: "100%",
                        padding: "8px 60px",
                        borderRadius: "8px",
                      }}
                      dropdownStyle={{}}
                      error={
                        formik.touched.contactno &&
                        Boolean(formik.errors.contactno)
                      }
                      // helperText={
                      //   formik.touched.contactno && formik.errors.contactno
                      // }
                    />
                  </div>
                </div>
                {formik.errors.contactno && formik.touched.contactno ? (
                  <p
                    style={{
                      color: "#d32f2f",
                      fontSize: "0.75rem",
                      marginTop: "-2px",
                      textAlign: "left",
                      paddingLeft: "0px",
                    }}
                  >
                    {
                      Data?.state?.statetwo?.detailsText?.phoneNumberError[
                        storelanguage?.code
                      ]
                    }
                    {/* {storelanguage?.name === "English"
                      ? "Please Enter Phone Number"
                      : "Por favor ingrese el número de teléfono"} */}
                  </p>
                ) : null}
              </div>
              <div className="DetailsPage-content-wrapper-inner Details_page_input_wrapper">
                <h3 className="DetailsPage-content-wrapper-inner_h3 !text-[14px]">
                  {
                    Data?.state?.statetwo?.detailsText?.nameTitle[
                      storelanguage?.code
                    ]
                  }
                  {/* {storelanguage?.name === "English" ? "Name*" : "Nombre*"}{" "} */}
                </h3>
                <TextField
                  style={{ marginTop: "8px", textAlign: "justify" }}
                  id="standard-size-normal"
                  fullWidth
                  variant="outlined"
                  value={formik.values.username}
                  name="username"
                  onChange={formik.handleChange}
                  placeholder="Enter the Full Name"
                  error={
                    formik.touched.username && Boolean(formik.errors.username)
                  }
                  inputProps={{
                    style: {
                      borderRadius: "8px",
                      border: "2px solid rgba(112, 112, 112, 0.53)",
                      fontSize: "14px",
                      // padding: "10px",
                    },
                  }}
                  className="customer__phone__number"
                  sx={{ backgroundColor: "white", border: "none!important" }}
                />
                {formik.errors.username && formik.touched.username ? (
                  <p
                    style={{
                      color: "#d32f2f",
                      fontSize: "0.75rem",
                      marginTop: "-2px",
                      textAlign: "left",
                      paddingLeft: "0px",
                    }}
                  >
                    {
                      Data?.state?.statetwo?.detailsText?.nameError[
                        storelanguage?.code
                      ]
                    }
                    {/* {storelanguage?.name === "English"
                      ? "User Name is required"
                      : "Se requiere nombre de usuario"} */}
                  </p>
                ) : null}
              </div>
              <div className="Details_page_agree_checkBox">
                <Checkbox
                  onChange={(e) => handleagreechange(e)}
                  defaultChecked={true}
                  {...label}
                  error={formik.touched.agree && Boolean(formik.errors.agree)}
                  // helperText={formik.touched.agree && formik.errors.agree}
                  style={{
                    cursor: "pointer",
                  }}
                />
                <p>
                  {
                    Data?.state?.statetwo?.detailsText?.agreement?.text1[
                      storelanguage?.code
                    ]
                  }
                  {/* {storelanguage?.name === "English"
                    ? "I Agree to receive delivery notification via SMS at the number provided above"
                    : "Acepto recibir notificación de entrega por SMS al número proporcionado arriba"}{" "}
                  {storelanguage?.name === "English"
                    ? "and accept"
                    : "y aceptar"}{" "} */}
                  <Link
                    to={"/help"}
                    className="Help_page-content-p_two"
                    // href="mailto:support@ottonomy.io"
                  >
                    {" "}
                    {
                      Data?.state?.statetwo?.detailsText?.agreement?.text2[
                        storelanguage?.code
                      ]
                    }
                    {/* {storelanguage?.name === "English"
                      ? "Privacy Policy"
                      : "política de privacidad"} */}{" "}
                  </Link>{" "}
                  {
                    Data?.state?.statetwo?.detailsText?.agreement?.text3[
                      storelanguage?.code
                    ]
                  }
                  <Link
                    to={"/help"}
                    className="Help_page-content-p_two"
                    // href="mailto:support@ottonomy.io"
                  >
                    {" "}
                    {
                      Data?.state?.statetwo?.detailsText?.agreement?.text4[
                        storelanguage?.code
                      ]
                    }{" "}
                  </Link>{" "}
                </p>
              </div>
            </div>
            <div className="BillDetails_page_BillTotal_wrapper">
              {storetype === "self" && (
                <div className="d_flex_center">
                  <h3 className="!text-black">
                    {" "}
                    {
                      Data?.state?.statetwo?.detailsText?.cart?.title[
                        storelanguage?.code
                      ]
                    }
                    {/* {storelanguage?.name === "English"
                      ? "Cart"
                      : "Detalles del pedido"} */}
                  </h3>
                </div>
              )}
              <div className="DetailsPage-content-wrapper">
                {cart && cart.length > 0 && (
                  <>
                    {cart
                      .filter(
                        (cartObj, index) =>
                          cart.findIndex(
                            (item) =>
                              Object.keys(item)[0] === Object.keys(cartObj)[0]
                          ) === index
                      )
                      .map((cartItem, index) => {
                        return (
                          <Fragment key={"cart__item__no__" + index}>
                            {!Array.isArray(Object.values(cartItem)[0]) ? (
                              <div
                                key={"cartItem" + index}
                                className={`mb-2 cart__item__list__container ${
                                  cart.length === 1 &&
                                  "border-b-[0.25rem] border-b-[var(--theme-primary)] !mb-0 pb-[12px]"
                                }`}
                              >
                                <>
                                  <div className="h-full product-content-wrapper">
                                    {/* <span
                                className="cart__order__delete"
                                onClick={() =>
                                  deleteCartItem(cartItem.product, cartItem)
                                }
                              >
                                <RxCross2 className="cart__order__delete__icon" />
                              </span> */}
                                    {/* <div className="product-content-wrapper-inner-div-one">
                                <img
                                  src={
                                    Array.isArray(Object.values(cartItem)[0])
                                      ? Object.values(cartItem)[0][0].product
                                          .image
                                      : cartItem.product?.image
                                  }
                                  className="product-images-class"
                                  alt=""
                                />
                              </div> */}
                                    <div className="product-content-wrapper-inner-div-two">
                                      <h4 className="!text-[14px] !leading-5 !line-clamp-2">
                                        {" "}
                                        <>
                                          {Array.isArray(
                                            Object.values(cartItem)[0]
                                          )
                                            ? `${
                                                Object.values(cartItem)[0][0]
                                                  .product?.name[
                                                  storelanguage?.code
                                                ]
                                              } - ${
                                                Object.values(cartItem)[0][0]
                                                  .productVariant?.name[
                                                  storelanguage?.code
                                                ]
                                              }`
                                            : cartItem?.product?.name[
                                                storelanguage?.code
                                              ]}
                                        </>
                                      </h4>
                                      {/* <span className="Bill_Details_content_itemcount"> */}
                                      {/* x {cartItem.count} */}
                                      {/* {variantCount(cartItem)} */}
                                      {/* </span> */}
                                      {/* <div className='Bill_Details_content_itemcount'> <h3>  </h3></div>  */}
                                    </div>
                                  </div>
                                  <div className="cart__product__list__container">
                                    <div className="cart__product__list__wrapper">
                                      {cart && (
                                        <>
                                          <button
                                            className="ItemsListPage-ItemsList-Counter-btn !py-[5px]"
                                            onClick={() => {
                                              // console.log(cartItem.product, "CART ITEM PRODUCT")
                                              // console.log(cartItem, "CART ITEM")
                                              let variantDetails =
                                                Object.values(cartItem)[0];

                                              if (
                                                typeof variantDetails ===
                                                "number"
                                              ) {
                                                variantDetails = undefined;
                                              }
                                              // console.log("variant Details", variantDetails)
                                              dispatch(
                                                DecrementCount(
                                                  cartItem.product,
                                                  cart,
                                                  totalPrice,
                                                  variantDetails
                                                )
                                              );
                                            }}
                                          >
                                            {" "}
                                            -{" "}
                                          </button>
                                          <input
                                            type="number"
                                            style={{
                                              WebkitAppearance: "none",
                                              margin: 0,
                                              color: "var(--theme-primary)",
                                              minWidth: "20px",
                                            }}
                                            readOnly
                                            // value={calculateQuantity(cartItem.product, cart)}
                                            value={variantCount(cartItem)}
                                            className="ItemsListPage-ItemsList-Counter-input"
                                          />
                                          <button
                                            className="ItemsListPage-ItemsList-Counter-btn !py-[5px]"
                                            onClick={() => {
                                              let variantDetails =
                                                Object.values(cartItem)[0];

                                              if (
                                                typeof variantDetails ===
                                                "number"
                                              ) {
                                                variantDetails = undefined;
                                              }
                                              // console.log("variant Details", variantDetails)

                                              dispatch(
                                                IncrementCount(
                                                  cartItem.product,
                                                  cart,
                                                  totalPrice,
                                                  variantDetails
                                                )
                                              );
                                            }}
                                          >
                                            {" "}
                                            +{" "}
                                          </button>{" "}
                                        </>
                                      )}
                                    </div>
                                    <span className="cart__order__price text-[14px] !font-normal">
                                      {Array.isArray(Object.values(cartItem)[0])
                                        ? currencyFormatter(
                                            Object.values(
                                              cartItem
                                            )[0][0]?.product?.price.toFixed(2),
                                            storeCurrency
                                          )
                                        : currencyFormatter(
                                            (
                                              cartItem.product?.price *
                                              itemsCount(cartItem)
                                            ).toFixed(2),
                                            storeCurrency
                                          )}
                                    </span>
                                  </div>
                                </>
                              </div>
                            ) : (
                              <div
                                key={"cartItem" + index}
                                className={`px-[10px] ${
                                  index !==
                                  cart.filter(
                                    (cartObj, index) =>
                                      cart.findIndex(
                                        (item) =>
                                          Object.keys(item)[0] ===
                                          Object.keys(cartObj)[0]
                                      ) === index
                                  ).length -
                                    1
                                    ? "border-b-[#ddd] border-b-[2px] border-solid pb-[12px] mb-2"
                                    : "border-b-[var(--theme-primary)] border-b-[0.25rem] border-solid pb-[12px] mb-2"
                                } items-center flex ${
                                  index !== 0 ? "pt-[1rem]" : ""
                                }`}
                              >
                                <div className="h-full product-content-wrapper">
                                  <div className="gap-2 product-content-wrapper-inner-div-two">
                                    <h4 className="!text-[14px] !leading-5 !line-clamp-2">
                                      {
                                        Object.values(cartItem)[0][0].product
                                          ?.name[storelanguage?.code]
                                      }
                                    </h4>
                                    <div className="mb-0 variant__increment__modal__variant__details__wrapper">
                                      <div className="variant__increment__modal__variant__wrapper">
                                        {cart && (
                                          <CalculateVariantsQuantity
                                            key={
                                              "calculate__variant__quantity__" +
                                              index
                                            }
                                            cartItems={cart.reduce(
                                              (newCartItem, oldCartItem) => {
                                                if (
                                                  Array.isArray(
                                                    Object.values(
                                                      oldCartItem
                                                    )[0]
                                                  ) &&
                                                  Object.keys(cartItem)[0] ===
                                                    Object.keys(oldCartItem)[0]
                                                ) {
                                                  newCartItem.push(
                                                    Object.values(
                                                      oldCartItem
                                                    )[0][0]
                                                  );
                                                }
                                                return newCartItem;
                                              },
                                              []
                                            )}
                                            // setIncrementVariantsModal={setIncrementVariantsModal}
                                          />
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                            {/* {index !==
                              cart.filter(
                                (cartObj, index) =>
                                  cart.findIndex(
                                    (item) =>
                                      Object.keys(item)[0] ===
                                      Object.keys(cartObj)[0]
                                  ) === index
                              ).length -
                                1 && (
                              <hr className="m-0 border-solid border-b border-b-[rgba(0,0,0,1)] opacity-30" />
                            )} */}
                          </Fragment>
                        );
                      })}
                  </>
                )}
                {/* <div className="mb-2 cart__item__list__container">
                  Selected Loc
                </div> */}
                {Data?.state?.statetwo?.deliveryfee &&
                  Data?.state?.statetwo?.deliveryfee > 0 ? (
                    <section className="BillDetails_item_topay_wrapper !pr-[10px] !pl-[15px]">
                      <div className="self-center text_align_start">
                        {" "}
                        <p className="!text-[14px] !text-black">
                          {" "}
                          {
                            Data?.state?.statetwo?.detailsText?.cart
                              ?.deliveryFee[storelanguage?.code]
                          }
                          {/* {storelanguage?.name === "English"
                        ? "Selected Location:"
                        : "Punto de recogida seleccionado:"} */}{" "}
                        </p>
                      </div>
                      <div className="flex flex-col text_align_end">
                        {" "}
                        <span className="!font-normal !text-[14px] !text-black">
                          {currencyFormatter(
                            (Data?.state?.statetwo?.deliveryfee).toFixed(2),
                            storeCurrency
                          )}
                        </span>
                        {/* <span className="!font-bold !text-[14px] !text-[var(--theme-primary)] !capitalize">
                      {locationName.locationName[storelanguage?.code]
                        ?.split("_")
                        ?.join(" ")
                        ?.toLowerCase()}
                    </span> */}
                      </div>
                    </section>
                  ): null}
                <div className="BillDetails_item_topay_wrapper !pr-[10px] !pl-[15px]">
                  <div className="self-center text_align_start">
                    {" "}
                    <p className="!text-[14px] !text-black">
                      {" "}
                      {
                        Data?.state?.statetwo?.detailsText?.cart
                          ?.selectedLocation[storelanguage?.code]
                      }
                      {/* {storelanguage?.name === "English"
                        ? "Selected Location:"
                        : "Punto de recogida seleccionado:"} */}{" "}
                    </p>
                  </div>
                  <div className="flex flex-col text_align_end">
                    {" "}
                    <span className="!font-normal !text-[14px] !text-black">
                      {storelanguage?.name === "English"
                        ? locationName?.group?.split("_")?.join(" ")
                        : locationName?.group?.split("_")?.join(" ")}
                    </span>
                    <span className="!font-bold !text-[14px] !text-[var(--theme-primary)] !capitalize">
                      {locationName.locationName[storelanguage?.code]
                        ?.split("_")
                        ?.join(" ")
                        ?.toLowerCase()}
                    </span>
                  </div>
                </div>
              </div>
              {/* <div className="DetailsPage-content-wrapper !px-[20px]">
                {storetype === "self" && (
                  <>
                    {cart &&
                      cart?.map((cartItem, index) => {
                        return (
                          <div
                            key={"cart__item__no__" + index}
                            className=" BillDetails_item_total_wrapper"
                          >
                            <div className="text_align_start">
                              {" "}
                              <p
                                style={{
                                  fontWeight: "bold",
                                }}
                              >
                                {" "}
                                {storelanguage?.name === "English" ? (
                                  <>
                                    {Array.isArray(Object.values(cartItem)[0])
                                      ? Object.values(cartItem)[0][0].product
                                          ?.en?.name
                                      : cartItem.product?.en?.name}
                                  </>
                                ) : (
                                  <>
                                    {Array.isArray(Object.values(cartItem)[0])
                                      ? Object.values(cartItem)[0][0].product
                                          ?.it?.name
                                      : cartItem.product?.it?.name}
                                  </>
                                )}
                              </p>
                            </div>
                            <div
                              className="text_align_end"
                              style={{
                                fontWeight: "bold",
                              }}
                            >
                              {" "}
                              {variantCount(cartItem)}
                             
                            </div>
                          </div>
                        );
                      })}{" "}
                  </>
                )}
                <div className="BillDetails_item_topay_wrapper">
                  <div className="text_align_start">
                    {" "}
                    <p>
                      {" "}
                      {storelanguage?.name === "English"
                        ? "Selected Delivery Location:"
                        : "Punto de recogida seleccionado:"}{" "}
                    </p>
                  </div>
                  <div className="text_align_end">
                    {" "}
                    <span
                      style={{
                        fontWeight: "800",
                      }}
                    >
                      {" "}
                      {storelanguage?.name === "English"
                        ? locationName.locationName.split("_").join(" ")
                        : locationName.spanishLocationName.split("_").join(" ")}
                    </span>
                  </div>
                </div>
              </div> */}
            </div>
            <div
              className={`Billpage_proceed_tonext_btn_wrapper ${
                formik.values.contactno.replace(storeConturyCode, "") !== "" &&
                formik.values.username !== "" &&
                formik.values.agree
                  ? "!bg-[var(--theme-primary)]"
                  : "!bg-[#707070]"
              }`}
            >
              <h3 className="!text-white text-[22px]">
                {" "}
                {currencyFormatter(
                  (totalPrice + deliveryCharge).toFixed(2),
                  storeCurrency
                )}
              </h3>
              <button
                className={`BillPage_proceed_to_btn !text-[16px] ${
                  formik.values.contactno.replace(
                    "+" + storeConturyCode,
                    ""
                  ) !== "" &&
                  formik.values.username !== "" &&
                  formik.values.agree
                    ? "!text-[var(--theme-primary)]"
                    : "!text-[#707070]"
                }`}
                disabled={
                  formik.values.contactno.replace(storeConturyCode, "") !==
                    "" &&
                  formik.values.username !== "" &&
                  formik.values.agree
                    ? false
                    : true
                }
              >
                {" "}
                {
                  Data?.state?.statetwo?.detailsText?.cart?.continue[
                    storelanguage?.code
                  ]
                }
                {/* {storelanguage?.name === "English" ? "Continue" : "Continuar"} */}
              </button>
              {/* )} */}
            </div>
            {/* <div className="Billpage_proceed_tonext_btn_wrapper">
              <h3 className="!text-white text-2xl">
                {" "}
                {currencyFormatter(
                  (totalPrice + deliveryCharge).toFixed(2),
                  storeCurrency
                )}
              </h3>
              {formik.errors.agree && formik.touched.agree ? (
                <p className="SelectDelivery_page_error_p">
                  {" "}
                  {storelanguage?.name === "English"
                    ? "Please Agree to Terms and conditions"
                    : "Por favor acepte los términos y condiciones"}{" "}
                </p>
              ) : (
                <>
                  {formik.values.contactno === "" ? (
                    <div className="Details_page_disabled_button">
                      {" "}
                      {storelanguage?.name === "English"
                        ? "Continue"
                        : "Continuar"}{" "}
                    </div>
                  ) : (
                    <button
                      type="submit"
                      className="Details_page__button"
                      style={{ cursor: "pointer" }}
                    >
                      {storelanguage?.name === "English" ? "Continue" : "Continuar"}
                    </button>
                  )}
                </>
              )}
            </div> */}
          </form>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Details;
